import { useState, useEffect, FC } from "react";
import FormRow from "../formRow/FormRow";
import CustomToggle from "../CustomToggle";

import { Field, getIn, useFormikContext } from "formik";
import { BooleanInputGroup } from "../../../types/modulesInterfaces";
import { useAppSelector, useCustomTranslation } from "../../../app/hooks";
import { selectIsFetchingData } from "../../../app/features/builder/builderSlice";

const BooleanInput: FC<BooleanInputGroup> = ({
	inputName,
	label,
	index,
	unit,
	disabled,
	comment,
	help,
	autosubmit,
}) => {
	const [name, setName] = useState<string>("");
	const isFetchingData: boolean = useAppSelector(selectIsFetchingData);
	const { errors, touched, setFieldValue } = useFormikContext();
	const translatedLabel = useCustomTranslation(label);

	useEffect(() => {
		setName(
			typeof inputName === "function" ? inputName(index ?? 0) : inputName,
		);

		return () => {
			setName("");
		};
	}, [inputName, index]);

	return (
		<FormRow
			rowComment={comment}
			rowHelp={help}
			isFetching={isFetchingData}
			error={
				getIn(errors, name) && getIn(touched, name)
					? getIn(errors, name)
					: undefined
			}
		>
			<Field
				label={label}
				labelSuffixValue={unit}
				name={name}
				id={name}
				component={CustomToggle}
				disabled={disabled}
				setFieldValue={setFieldValue}
				autosubmit={autosubmit}
			/>
		</FormRow>
	);
};

export default BooleanInput;
